// One of a few values, all visible at once: the direction and the state of a deal (TX-US-0039).
// Radio inputs underneath, so the group is one tab stop, the arrow keys move within it, and a
// screen reader announces it as a choice of one.

import { useId } from 'react';

export default function SegmentedChoice({ label, options, value, onChange, error, flag = null }) {
  const name = useId();

  return (
    <fieldset className="field segmented-field">
      <legend className="field-label">{label}{flag}</legend>
      <span className="segmented">
        {options.map((option) => (
          <label key={option.value} className={value === option.value ? 'chosen' : undefined}>
            <input type="radio" name={name} value={option.value}
                   checked={value === option.value}
                   onChange={() => onChange(option.value)} />
            {option.label}
          </label>
        ))}
      </span>
      {error && <span className="field-error">{error}</span>}
    </fieldset>
  );
}
